import React from 'react';
import { FileTextIcon, LockIcon, ZapIcon } from 'lucide-react';
import { DOWNLOADS, MOCKUP_IMAGE, PRICE } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
import { CtaButton } from './CtaButton';
import { ViewerCounter } from './ViewerCounter';
import { GuaranteeSection } from './GuaranteeSection';
type PriceSectionProps = {
  onBuy: () => void;
};
const trustItems = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function PriceSection({
  onBuy
}: PriceSectionProps) {
  const {
    minutes,
    seconds
  } = useCountdown(600);
  const units = [{
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEG'
  }];
  return <section id="precio" className="bg-cream px-5 py-10 sm:px-8 lg:py-14" data-id="element-74" data-mp="osa7cmq6d08a">
      <div className="mx-auto w-full max-w-[520px]" data-id="element-75" data-mp="oq60px0w5n4b">
        <ViewerCounter data-id="element-76" data-mp="krq8nepydok1" />

        <div className="mt-6 flex w-full items-center justify-center" data-id="element-77" data-mp="kr6sa2fyb884">
          <img src={MOCKUP_IMAGE} alt="Ebook Libres de Ser" loading="lazy" decoding="async" width={520} height={520} className="w-full max-w-[360px] rounded-3xl shadow-soft" data-id="element-78" data-mp="1mhkoeha6lqmd" />
        </div>

        <div className="mt-8" data-id="element-79" data-mp="1dipil6b1uijl">
          <span className="animate-badge-pulse inline-flex items-center gap-1.5 rounded-full bg-butter px-4 py-1.5 font-sans text-[14px] font-bold text-ink" data-id="element-80" data-mp="1djihxm7oi5rp">
            +{DOWNLOADS} descargas 🚀
          </span>

          <h2 className="mt-4 font-display text-[32px] font-semibold uppercase leading-[1.1] text-ink sm:text-[38px]" data-id="element-81" data-mp="25b6pzwjfc64q">
            Libres de Ser
          </h2>

          <div className="mt-4 flex items-baseline gap-3" data-id="element-82" data-mp="1wfqpiwo5ysq6">
            <p className="font-display text-[52px] font-semibold leading-none text-coral sm:text-[58px]" data-id="element-83" data-mp="20idln9rvazt6">
              {PRICE.current}
            </p>
            <p className="font-sans text-[18px] text-muted line-through" data-id="element-84" data-mp="2o76ayndzi9et">
              {PRICE.original}
            </p>
          </div>

          <span className="animate-badge-pulse mt-4 inline-flex items-center gap-1.5 rounded-full bg-urgent px-4 py-2 font-sans text-[13px] font-bold uppercase tracking-[0.04em] text-white" data-id="element-85" data-mp="2t0iy0t30m85g">
            {PRICE.discount} · últimos cupos 🔥
          </span>
        </div>

        <div className="mt-8" data-id="element-86" data-mp="2tsf894rkrqs2">
          <CtaButton label="Agregar al carrito" onClick={onBuy} data-id="element-87" data-mp="2tvt7i44xzjva" />
        </div>

        <div className="mt-4 rounded-2xl border border-coral/25 bg-white px-5 py-6 text-center" data-id="element-88" data-mp="2ouncu0rq1mj4">
          <p className="flex items-center justify-center gap-2 font-display text-[19px] font-semibold uppercase text-coral" data-id="element-89" data-mp="2jx3twnk2wlku">
            <ZapIcon aria-hidden="true" className="h-5 w-5" strokeWidth={2.2} data-id="element-90" data-mp="2b3id6yocsu8s" />
            Oferta solo por hoy!
          </p>

          <div className="mt-5 flex items-start justify-center gap-2" data-id="element-91" data-mp="26572klq8ifpi">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-92" data-mp="215koyb6huxg6" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="font-display text-[30px] font-semibold leading-none text-ink/20" data-id="element-93" data-mp="2175jw1wq0iek">
                    :
                  </span>}
                <div className="min-w-[76px] rounded-xl bg-blush/70 px-3 py-3" data-id="element-94" data-mp="1m1hxfcsu485o">
                  <p className="font-display text-[34px] font-semibold leading-none tabular-nums text-ink" data-id="element-95" data-mp="1r0l0wst626bj">
                    {unit.value}
                  </p>
                  <p className="mt-1.5 font-sans text-[11px] font-medium tracking-[0.16em] text-muted" data-id="element-96" data-mp="20zk1do3s2vng">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <p className="mt-5 font-sans text-[14px] leading-relaxed text-ink-soft" data-id="element-97" data-mp="18a3dn3r3s2xk">
            Reserva válida por 10 minutos. Si no accedés, tu descuento pasa a la
            siguiente persona.
          </p>
        </div>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-98" data-mp="1i1hi7pxwvsxk">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 font-sans text-[13px] text-ink-soft" data-id="element-99" data-mp="pk57it6v8jwk">
              <Icon aria-hidden="true" className="h-4 w-4 text-muted" data-id="element-100" data-mp="2r91adpgrz2ny" />
              {label}
            </li>)}
        </ul>

        <div className="mt-4" data-id="element-101" data-mp="2mbixxp3ju5b7">
          <GuaranteeSection data-id="element-102" data-mp="2mcasqxpbnz0f" />
        </div>
      </div>
    </section>;
}